import * as GlossaryService from './glossary_service';

export { GlossaryService };
